import * as React from "react";
import { useState, useEffect } from "react";
import publicLogoIcon from "../assets/public_logo.svg";
import { Box, Typography } from '@mui/material';

const PublicLogo: React.FC = () => {
  return (
    <>
      <Box
          display="flex"
          justifyContent="left"
          alignItems="center"
          height="115px"
          width="100%"
          bgcolor="#ffffff"
          sx={{
              borderRadius: "16px",
          }}
          p={"20px"}
      >
        <img
            src={publicLogoIcon}
            alt="logo"
            style={{
                height: 64,
                width: 64,
            }}
        />

        <Box
          display="flex"
          flexDirection="column"
          ml={2}
        >
          <Typography
            sx={{
              width: "100%",
              fontFamily: "Inter, sans-serif",
              fontWeight: 700,
              fontSize: 48,
              lineHeight: "100%",
              letterSpacing: "-0.04em",
              color: "#1C492D",
              m: 0,
            }}
          >
            Nimbleness
          </Typography>
          <Typography
            sx={{
              width: "100%",
              fontFamily: "Inter, sans-serif",
              fontWeight: 400,
              fontSize: 20,
              lineHeight: "100%",
              color: "#1C492D",
              m: 0,
            }}
          >
            Vendesi Leggerezza
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export default PublicLogo;

